import { useState, useEffect } from "react";
import {
  TextField,
  Box,
  Typography,
  CardMedia,
  Card,
  Button,
  Avatar,
  Menu,
} from "@mui/material";
import { rsProgress } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseLandingFooter } from "./UseLandingFooter";
import { useNavigate, useLocation } from "react-router-dom";
import { FileUploader } from "react-drag-drop-files";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import useBreakpoints from "../../../hooks/useBreakpoints";
import { SketchPicker } from "react-color";

export default function FooterInpho() {
  const location = useLocation();
  const navigate = useNavigate();
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetFooter, SetFooter } = UseLandingFooter();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [state, setState] = useState({
    id: undefined,
    backgroundColor: "",
    urL1: undefined,
    title1: undefined,
  });
  const { isSmall } = useBreakpoints();

  const [imgState, setImgState] = useState({
    imageFile1: undefined,
    imageUrl1: undefined,
  });

  useEffect(() => {
    if (location.state.id) {
      setProgress(true);
      GetFooter(
        location.state.id,
        (footer) => {
          setImgState({
            ...imgState,
            imageUrl1: footer.logo1 ? footer.logo1 : "",
          });
          setState({
            id: footer.id !== 0 ? footer.id : location.state.id,
            backgroundColor: footer.backgroundColor
              ? footer.backgroundColor
              : "",
            urL1: footer.urL1 ? footer.urL1 : "",
            title1: footer.title1 ? footer.title1 : "",
          });
        },
        true
      );
    }
  }, [location.state]);

  return (
    <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
      <Box gridColumn="span 12" sx={{ display: "flex", alignItems: "center" }}>
        <FiberManualRecordIcon color="secondary" fontSize="small" />
        <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
          اطلاعات فوتر
        </Typography>
      </Box>
      {/* <Box gridColumn={isSmall ? "span 12" : "span 2"}>
        <FileUploader
          multiple={true}
          handleChange={(evt) => handleChangeImage1(evt)}
          name="file"
          types={fileTypes}
          children={
            <Box sx={{ width: "150px", height: "auto" }}>
              <Card
                sx={{
                  p: 1,
                  border: "1px",
                  borderStyle: "dashed",
                  borderColor: "secondary.main",
                  borderRadius: 4,
                  boxShadow: 0,
                  cursor: "pointer",
                  bgcolor: "#d3d3d3",
                }}
              >
                <CardMedia
                  component="img"
                  sx={{ width: "100%", height: "100%" }}
                  image={
                    imgState.imageUrl1
                      ? imgState.imageUrl1
                      : "/static/img/no-photos.png"
                  }
                />
              </Card>
            </Box>
          }
        />
      </Box>
      <Box gridColumn={isSmall ? "span 12" : "span 4"}>
        <TextField
          fullWidth
          sx={{
            textarea: { direction: "rtl" },
          }}
          multiline
          maxRows={4}
          value={state.urL1 ? state.urL1 : ""}
          label="لینک تصویر"
          size="small"
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, urL1: evt.target.value });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box> */}
      {/* {!isSmall && <Box gridColumn="span 6"></Box>} */}
      <Box gridColumn={isSmall ? "span 12" : "span 6"}>
        <TextField
          fullWidth
          value={state.title1 ? state.title1 : ""}
          label="عنوان"
          size="small"
          multiline
          maxRows={3}
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, title1: evt.target.value });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      {!isSmall && <Box gridColumn="span 6"></Box>}
      <Box gridColumn={isSmall ? "span 12" : "span  3"}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography color="secondary" variant="body1">
            رنگ پس زمینه:
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #D7D7D7",
              borderRadius: 2,
              p: 1,
              ml: 2,
            }}
          >
            <Avatar
              sx={{
                bgcolor: state.backgroundColor,
                boxShadow: 3,
                width: 75,
                height: 30,
                mx: 1,
                borderRadius: 1,
              }}
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={(event) => setAnchorEl(event.currentTarget)}
            >
              {" "}
            </Avatar>
            <Typography variant="body1">
              {state.backgroundColor ? state.backgroundColor : ""}
            </Typography>
          </Box>
          {state.backgroundColor ? (
            <Button
              sx={{ ml: 2 }}
              variant="outlined"
              onClick={(color) => {
                setState({ ...state, backgroundColor: "" });
              }}
            >
              حذف
            </Button>
          ) : (
            ""
          )}
        </Box>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={() => setAnchorEl(null)}
          sx={{
            "& .muirtl-6hp17o-MuiList-root-MuiMenu-list": {
              py: 0,
            },
          }}
        >
          <SketchPicker
            sx={{ position: "relative", top: "-130px" }}
            color={state.backgroundColor ? state.backgroundColor : ""}
            onChangeComplete={(color) => {
              setState({ ...state, backgroundColor: color.hex });
            }}
          />
        </Menu>
      </Box>
      {!isSmall && <Box gridColumn="span 9"></Box>}
      <Box
        gridColumn="span 6"
        sx={{ display: "flex", justifyContent: "flex-end" }}
      >
        <Button
          sx={{ width: "100px" }}
          variant="contained"
          onClick={() => {
            //   if (validateItem(state, setErrorState) == 200) {
            setProgress(true);
            SetFooter(state, imgState.imageFile1, (calback) => {
              navigate("/landingmanagment/landingComponents", {
                state: { ...location.state, isBack: true },
                replace: true,
              });
            });
            //   }
          }}
        >
          ثبت
        </Button>
      </Box>
    </Box>
  );
}
